<template>
    <div class="aside-content p-2">
        <header class="d-flex">
            <h4>{{ title }}</h4>
            <b-button-close
                @click="dismiss()"
                class="ml-auto border-left pl-2"
            />
        </header>
        <hr class="my-2" />
        <slot></slot>
        <hr />
        <div class="float-right">
            <b-button
                class="mr-2"
                variant="secondary"
                size="sm"
                @click="dismiss()"
                >{{ $t('form.button.cancel') }}</b-button
            >
            <b-button
                @click="$emit('okHandler', closeAside)"
                variant="primary"
                size="sm"
            >
                <slot name="okButton">
                    <span>{{ $t('form.button.save') }}</span>
                </slot>
            </b-button>
        </div>
    </div>
</template>

<script>
import Aside from '@/shared/aside'

export default {
    name: 'DefaultAside',
    props: ['title'],
    methods: {
        dismiss() {
            Aside.close(this.forceClear)
        },
        closeAside(result) {
            Aside.close(result)
        },
    },
}
</script>

<style scoped lang="css">
.aside-content {
    /* 105px eh a altura do header + footer, TODO: refatorar para obter essas variaveis e calcular */
    height: calc(100vh - 105px);
    overflow-y: auto;
}
</style>
